import { stenaPercentage } from "@stenajs-webui/elements";
import * as React from "react";
import { useFilterWorkspace } from "../../hooks/UseFilterWorkspace";
import { RangeFilter } from "../../types/RangeFilter";
import { FppSearchFilterSection } from "../FppSearchFilterSection";
import { RangeControl } from "../RangeControl";

interface Props {
  enabled?: boolean;
  label?: string;
  labelFrom?: string;
  labelTo?: string;
  maxDecimals?: number;
  maxNumbers?: number;
}

export const RateFilterSection: React.FC<Props> = ({
  enabled,
  label,
  labelFrom,
  labelTo,
  maxDecimals,
  maxNumbers,
}) => {
  const { rate, setRate } = useFilterWorkspace();

  const onFilterValueChange = (rangeFilter: RangeFilter) => {
    setRate({ ...rangeFilter });
  };

  const numberOfActiveFilters = () => {
    return rate.from || rate.to ? 1 : 0;
  };

  return (
    <FppSearchFilterSection
      sectionId={"rate"}
      label={label}
      enabled={enabled}
      numSelected={numberOfActiveFilters()}
      leftIcon={stenaPercentage}
      children={
        <RangeControl<RangeFilter>
          value={rate}
          valueFrom={rate.from}
          valueTo={rate.to}
          onValueChange={onFilterValueChange}
          labelFrom={labelFrom ?? "From"}
          labelTo={labelTo ?? "To"}
          maxNumbers={maxNumbers}
          maxDecimals={maxDecimals}
        />
      }
    />
  );
};
